export default "__VITE_PUBLIC_ASSET__dc936383__"